type Props = {
    percentage: string
    title: string
    description: string
  }
  
  export const StatInsightCard = ({ percentage, title, description }: Props) => {
    return (
      <div>
        <div className="hidden lg:block">
      <div className="bg-[#F3ECEC] h-[300px] max-[1179px]:h-[350px] rounded-[26px] p-10 border border-[#F1EAEA] hover:shadow-md transition">
  
        <h3 className="text-[64px] text-start font-semibold text-red-600 leading-none">
          {percentage}
          <span className="text-[32px]">%</span>
        </h3>
  
        <h4 className="text-[20px] text-start font-medium mt-6 text-gray-900">
          {title}
        </h4>
  
        <p className="text-[16px] text-start text-gray-600 mt-3 leading-relaxed">
          {description}
        </p>
  
      </div>
      </div>

      <div className="block lg:hidden">
      <div className="bg-[#F3ECEC] rounded-[26px] max-[1024px]:h-[280px] max-[867px]:h-[330px] max-[770px]:h-[350px] max-[768px]:h-[220px] max-[403px]:h-[250px] p-6 border border-[#F1EAEA] hover:shadow-md transition">
  
        <h3 className="text-[54px] font-semibold text-red-600 leading-none">
          {percentage}
          <span className="text-[28px]">%</span>
        </h3>
  
        <h4 className="text-[18px] font-medium mt-4 text-gray-900">
          {title}
        </h4>
  
        <p className="text-[16px] text-gray-600 mt-1 leading-relaxed">
          {description}
        </p>
  
      </div>
      </div>
      </div>
      
    )
  }